<script lang="ts" setup>
defineOptions({
    name: 'IdeoFormGroup'
});

const props = withDefaults(defineProps<{
    label?: string;
    tag?: string;
    labelFor?: string;
    invalidFeedback?: string;
    state?: boolean;
    required?: boolean;
    nospace?: boolean;
    labelClass?: Record<string, boolean> | string[] | string;
}>(), {
    label: null,
    tag: 'span',
    labelFor: null,
    invalidFeedback: null,
    state: null,
    labelClass: () => ({})
});

const loaded = ref(false);
const helpicon = ref(null);

const invalid = computed(() => props.state === false || (props.state === null && !!props.invalidFeedback));

const labelClasses = computed(() => ({
    'w-100 d-flex align-items-center gap-2': true,
    'text-danger': invalid.value,
    ...normalizeClasses(props.labelClass)
}));

const flag = (value: any): boolean =>
{
    return value !== false;
};

const onClick = (e: any): void =>
{
    if (!props.labelFor)
        e.stopPropagation();
};

onMounted(() =>
{
    loaded.value = true;
});
</script>

+<template>
    <div class="form-group" :class="{ 'mb-0': flag(nospace), 'invalid': invalid }">
        <label v-if="label" :for="labelFor" :class="labelClasses" @click="onClick">
            <component :is="tag">
                {{ label }}

                <i v-if="$slots.help" ref="helpicon" class="far fa-fw fa-circle-question" />
            </component>
            <i v-if="flag(required) && !invalid" class="fa-solid fa-fw fa-star-of-life fa-2xs text-danger" />
            <i v-if="invalid" class="fa-solid fa-fw fa-triangle-exclamation" :title="invalidFeedback" />
        </label>
        <slot name="default" />
        <template v-if="$slots.description">
            <small class="form-text text-muted"><slot name="description" /></small><br>
        </template>
        <small v-if="invalid" class="form-text text-danger">{{ invalidFeedback }}</small>
        <template v-if="loaded && $slots.help">
            <IdeoPopover class="popover" :target="helpicon" placement="right" triggers="hover">
                <slot name="help" />
            </IdeoPopover>
        </template>
    </div>
</template>
